<template>
  <div class="profiles">
    <h2 class="mb-2 primary--text">PROFILES</h2>
    <v-form>
      <v-row>
        <v-col cols="12">
          <v-btn depressed color="primary" :disabled="!showSidebar" @click="editProfile(null)"
            >New Fund</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="profilesList"
            dense
            class="searchResults"
            @click:row="editProfile"
            item-key=""
            :items-per-page="-1"
            :loading="loading"
            loading-text="Loading profiles list..."
            :single-select="true"
            :calculate-widths="true"
          >
            <template
              v-for="header in headers.filter((header) => header.format !== '')"
              v-slot:[`item.${header.value}`]="{ item, value }"
            >
              {{ formatElement(item, value, header.format) }}
            </template>
            <template v-slot:[`item.DateInvested`]="{ item }">
              <span>{{ displayDate(new Date(item.DateInvested)) }}</span>
            </template>
          </v-data-table>

          <v-navigation-drawer
            v-if="isSidebarShown"
            fixed
            temporary
            right
            :width="sidebarWidth"
            stateless
            :value="isSidebarShown"
          >
            <v-container v-if="!showSwitch" class="sidebar">
              <h3>
                {{ isNew || isDuplicate ? 'Add new profile' : 'Edit profile details' }}
              </h3>

              <v-sheet
                v-if="!isNew && !isDuplicate"
                color="blue lighten-5"
                elevation="0"
                class="pa-4 mb-4"
                rounded
              >
                <div class="currentValuation"><b>Current Valuation</b></div>
                <div class="currentValuationValues">
                  <div>
                    <span>Offer Price</span>&nbsp;<span>{{
                      formatPrice(selectedProfile.OfferPrice, 4)
                    }}</span>
                  </div>
                  <div>
                    <span>Bid Price</span>&nbsp;<span>{{
                      formatPrice(selectedProfile.BidPrice, 4)
                    }}</span>
                  </div>
                  <div>
                    <span>Price Date</span>&nbsp;<span>{{
                      this.selectedProfile.PriceDateString
                    }}</span>
                  </div>
                  <div>
                    <span>Total Units</span>&nbsp;<span>{{
                      formatPrice(selectedProfile.UnitsHeld, 5)
                    }}</span>
                  </div>
                  <div>
                    <span>Total Value</span>&nbsp;<span>{{
                      formatPrice(selectedProfile.UnitsHeld * selectedProfile.BidPrice, 2)
                    }}</span>
                  </div>
                </div>
              </v-sheet>

              <div v-if="!isNew && !isDuplicate" class="mb-3">
                <v-btn plain class="mr-4 pa-0" color="primary" @click="duplicateFund"
                  >Duplicate new</v-btn
                >
                <v-btn plain class="ml-4 pa-0" color="primary" @click="onSwitch">Switch fund</v-btn>
                <v-btn plain class="ml-4 pa-0" color="primary" @click="onAdjustment"
                  >Adjustment</v-btn
                >
              </div>

              <v-form ref="form" v-model="isFormValid" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <div class="formPanel">
                      <v-select
                        label="Manager"
                        v-model="selectedProfile.ManagerId"
                        :items="managerList"
                        item-value="ManagerId"
                        item-text="ManagerName"
                        :rules="[(v) => !!v || 'Required']"
                        required
                      ></v-select>

                      <v-select
                        label="Fund"
                        v-model="selectedProfile.FundId"
                        :items="selectedManagerFundList"
                        item-value="PortfolioId"
                        item-text="PortfolioName"
                        :rules="[(v) => !!v || 'Required']"
                        required
                      ></v-select>

                      <v-select
                        label="Contribution Type"
                        :items="contributionTypes"
                        v-model="selectedProfile.ContributionType"
                        :rules="[(v) => !!v || 'Required']"
                        required
                      ></v-select>

                      <v-select
                        label="Investment Type"
                        :items="investmentTypes"
                        v-model="selectedProfile.InvestmentType"
                        :rules="[(v) => !!v || 'Required']"
                        required
                      ></v-select>
                      <v-text-field
                        type="number"
                        label="Invest Percentage"
                        v-model="selectedProfile.InvestPercent"
                        :rules="[(v) => (v !== null && v !== undefined && v !== '') || 'Required']"
                      ></v-text-field>
                      <v-select
                        v-model="selectedProfile.LifeStyleId"
                        label="Lifestyle"
                        :items="lifestyleList"
                        item-value="LifestyleId"
                        item-text="Name"
                      ></v-select>
                      <v-select
                        label="Status"
                        :items="statuses"
                        v-model="selectedProfile.Status"
                        :rules="[(v) => !!v || 'Required']"
                        required
                      ></v-select>
                    </div>
                  </v-col>

                  <!--
                  <v-col cols="6">
                    <div class="formPanel">
                      <DatePicker
                        label="Date Last Invested"
                        v-model="selectedProfile.DateLastInvested"
                      ></DatePicker>
                      <v-text-field
                        type="number"
                        label="Units Held"
                        v-model="selectedProfile.UnitsHeld"
                      ></v-text-field>
                      <v-text-field
                        type="number"
                        label="Bid Price"
                        v-model="selectedProfile.BidPrice"
                      ></v-text-field>
                      <v-text-field
                        type="number"
                        label="Contributions"
                        v-model="selectedProfile.Contributions"
                      ></v-text-field>
                      <DatePicker
                        label="Contribution Date"
                        v-model="selectedProfile.ContributionDate"
                      ></DatePicker>
                    </div>
                  </v-col>
                -->
                </v-row>

                <!--
                <TabForm
                  :formElements="formElements"
                  :readOnly="false"
                  :editDisabled="editDisabled"
                  @max_column="processSidebarWidth"
                />
              -->
              </v-form>

              <div class="btnsContainer">
                <div>
                  <v-btn outlined color="error" @click="onDelete">Delete</v-btn>
                </div>
                <div>
                  <v-btn outlined color="primary" @click="cancelChanges" class="ml-4">Cancel</v-btn>
                  <v-btn
                    depressed
                    color="primary"
                    @click="saveChanges"
                    class="ml-4"
                    :disabled="!isFormValid"
                    >Save</v-btn
                  >
                </div>
              </div>
            </v-container>

            <v-container v-else class="sidebar">
              <ProfilesSwitch
                @closeSwitch="showSwitch = false"
                :fundToSwitch="fundToSwitch"
                :unitsHeld="this.selectedProfile.UnitsHeld"
                :memberId="this.memberId"
                :sellProfile="this.selectedProfile"
              />
            </v-container>
          </v-navigation-drawer>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-sheet color="blue lighten-5" elevation="0" class="pa-4" width="600" rounded>
            <v-simple-table class="totalsTable" v-if="profilesList" dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-right"></th>
                    <th class="text-right">Active Contribution Check</th>
                    <th class="text-right">Contributions</th>
                    <th class="text-right">Values</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(type, i) in contributionTypesList" :key="i">
                    <td class="text-right">{{ type }}</td>
                    <td class="text-right">{{ formatTotalTable(type).percent }}</td>
                    <td class="text-right">{{ formatTotalTable(type).contributions }}</td>
                    <td class="text-right">{{ formatTotalTable(type).values }}</td>
                  </tr>
                  <tr>
                    <td class="text-right font-weight-bold">Totals</td>
                    <td class="text-right font-weight-bold"></td>
                    <td class="text-right font-weight-bold">
                      {{ totalContributions }}
                    </td>
                    <td class="text-right font-weight-bold">
                      {{ totalValues }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-sheet>
        </v-col>
      </v-row>
    </v-form>
    <Dialog ref="confirmationDialog" />
    <v-dialog v-model="showAdjustment" @keydown.esc="cancel" persistent width="500">
      <v-card>
        <v-card-title>Profile Adjustment</v-card-title>
        <div class="px-4 pt-4">
          <v-form ref="adjustmentForm" lazy-validation>
            <DatePicker
              label="Adjustment Date"
              v-model="profileAdjustment.AdjustmentDate"
              :rules="rules"
            ></DatePicker>
            <v-select
              v-model="profileAdjustment.AdjustmentType"
              label="Adjustment Type"
              :items="['Positive Adjustment', 'Negative Adjustment']"
              :rules="rules"
              outlined
              dense
            ></v-select>
            <v-text-field
              v-model="profileAdjustment.AdjustedUnits"
              label="Adjusted Units"
              type="number"
              :rules="rules"
              outlined
              dense
            ></v-text-field>
          </v-form>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="cancelAdjustment"> Cancel </v-btn>
          <v-btn color="primary" depressed @click="okAdjustment"> Ok </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
//import TabForm from '@/components/TabForm.vue';
import Utils from '@/utils.js';
import ProfilesSwitch from './ProfilesSwitch.vue';
import Dialog from '@/components/layout/Dialog.vue';
import DatePicker from '@/components/formControls/DatePicker.vue';
//import Dropdown from '@/components/formControls/Dropdown.vue';

export default {
  name: 'Profiles',
  components: {
    //TabForm,
    ProfilesSwitch,
    Dialog,
    DatePicker,
    //Dropdown,
  },
  props: {},

  data() {
    return {
      loading: false,
      isSidebarShown: false,
      sidebarWidth: 475,
      columnCount: 1,
      formElements: [],
      allElements: [],
      headers: [],
      profilesList: [],
      isFormValid: true,
      managerList: [],
      selectedProfile: null,
      selectedManagerFundList: [],
      showSwitch: false,
      showAdjustment: false,
      isDuplicate: false,
      investmentTypes: ['Regular', 'TransferIn'],
      statuses: ['Active', 'Inactive', 'Selling', 'Sold'],
      lifestyleList: [],
      contributionsType: ['Employee', 'Employer'],
      profileAdjustment: {},
      rules: [(v) => !!v || 'Required.'],
    };
  },

  computed: {
    memberId() {
      return this.$store.getters.selectedMemberId;
    },
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    isNew() {
      if (this.selectedProfile && this.selectedProfile.ProfileId) return false;
      return true;
    },
    totalContributions() {
      return (
        Math.round(
          this.profilesList
            //.filter((profile) => profile.Status === 'Active')
            .reduce((total, current) => (total += current.Contributions), 0)
            .toFixed(2) * 100
        ) / 100
      ).toFixed(2);
    },
    totalValues() {
      return (
        Math.round(
          this.profilesList
            //.filter((profile) => profile.Status === 'Active')
            .reduce((total, current) => (total += current.BidPrice * current.UnitsHeld), 0) * 100
        ) / 100
      ).toFixed(2);
    },
    managerId() {
      /*if (this.formElements && this.formElements.length) {
        return this.formElements.find((el) => el.FieldName === 'ManagerId').Value;
      }*/
      if (this.selectedProfile) {
        return this.selectedProfile.ManagerId;
      }

      return null;
    },
    editDisabled() {
      if (!this.isNew && !this.isDuplicate)
        return ['ManagerId', 'FundId', 'ContributionType', 'InvestmentType'];
      return [];
    },
    fundToSwitch() {
      if (this.selectedProfile) {
        return this.selectedProfile.ManagerName + '/' + this.selectedProfile.FundName;
      }
      return null;
    },
    contributionTypesList() {
      if (!this.profilesList || !this.profilesList.length) return [];
      const result = new Set();
      this.profilesList.forEach((p) => result.add(p.ContributionType));
      return Array.from(result);
    },
    showSidebar() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },

  watch: {
    memberId() {
      this.getProfileList();
    },
    managerId(newValue) {
      if (newValue) {
        this.getFundList(newValue);
      } else {
        this.selectedManagerFundList = [];
        if (this.selectedProfile) {
          this.selectedProfile.FundId = null;
        }
      }
    },
  },

  created() {
    this.getHeaders();
    this.getContributionTypes();
    this.getInvestmentTypes();
  },

  mounted() {
    if (!this.memberId) {
      this.$store.commit('setNotificationMessage', {
        type: 'info',
        text: 'Please, select member',
      });
      this.$router.push({ path: '/' });
    } else {
      this.getForm('InvestChoice');
      this.$root.currentPage = 'Investments';

      this.getManagerList();

      this.getLifestyleList();
    }
  },

  destroyed() {
    this.$root.currentPage = null;
  },

  methods: {
    formatPrice(value, dozens) {
      if (!value || !dozens) return null;
      let factor = '1';
      for (let i = 0; i < dozens; i++) {
        factor += '0';
      }
      factor = Number(factor);
      return (Math.round(value * factor) / factor).toFixed(dozens);
    },

    onAddNewProfile() {
      this.selectedProfile = {
        ProfileId: 0,
        ManagerId: 0,
        FundId: 0,
      };
    },

    async getContributionTypes() {
      try {
        let response = await this.$api.get('/profiles/GetContributionTypes');
        if (response && response.data.length) {
          this.contributionTypes = response.data;
        }
      } catch (err) {
        console.log(err);
      }
    },

    async getInvestmentTypes() {
      try {
        let response = await this.$api.get('/profiles/GetInvestmentTypes');
        if (response && response.data.length) {
          this.investmentTypes = response.data;
        }
      } catch (err) {
        console.log(err);
      }
    },

    editProfile(item) {
      if (!this.showSidebar) return;
      this.isSidebarShown = true;
      if (item) {
        const id = item.ProfileId;
        this.selectedProfile = { ...this.profilesList.find((profile) => profile.ProfileId === id) };
        /*if (this.selectedProfile) {
          //Utils.setDataToFormElements(this.selectedProfile, this.formElements);
          //var m = this.formElements.find((element) => element.FieldId == 'ManagerId');
          //if (m) m.Value = m.Value.toString();
        }*/
        return;
      } else {
        //this.formElements.forEach((el) => (el.Value = ''));
        this.selectedProfile = null;
        this.onAddNewProfile();
      }
    },

    cancelChanges() {
      this.isSidebarShown = false;
      this.selectedProfile = null;
      this.isDuplicate = false;
      this.selectedManagerFundList = [];
    },

    saveChanges() {
      this.isFormValid = this.$refs.form.validate();
      if (this.isFormValid) {
        this.isSidebarShown = false;
        if (this.isNew || this.isDuplicate) {
          this.isDuplicate = false;
          this.addProfile();
        } else {
          this.updateProfile();
        }
      }
    },

    async onDelete() {
      try {
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.isSidebarShown = false;
        this.deleteProfile();
      } catch (err) {
        console.log();
      }
    },

    onSwitch() {
      this.showSwitch = true;
    },

    onAdjustment() {
      this.showAdjustment = true;
    },

    displayDate(date) {
      if (date.getFullYear() <= 1900) return null;
      return Utils.getDateStr(date);
    },

    duplicateFund() {
      this.isDuplicate = true;
      this.selectedProfile.ProfileId = 0;
    },

    formatElement(item, value, format) {
      return Utils.formatTableValue(value, format);
    },

    formatTableEl(item, value, format) {
      if (format === '{0:#,###,##0.00}') {
        const formatContent = format.replace(/({|})/g, () => '');
        const dotIndex = formatContent.indexOf('.');
        const numOfFractionDigits = formatContent.slice(dotIndex + 1).length;
        const numberFormat = new Intl.NumberFormat('en-GB', {
          maximumFractionDigits: numOfFractionDigits,
          minimumFractionDigits: numOfFractionDigits,
        });
        const formatted = numberFormat.format(value);
        return formatted;
      } else if (format === '{0:d}') {
        return this.displayDate(new Date(value));
      }

      return value;
    },

    formatTotalTable(contType) {
      const result = {
        percent: 0,
        contributions: 0,
        values: 0,
      };
      this.profilesList
        .filter((profile) => profile.ContributionType === contType)
        .forEach((cont) => {
          if (cont.Status === 'Active') {
            result.percent += cont.InvestPercent;
          }
          result.contributions += cont.Contributions;
          result.values += cont.BidPrice * cont.UnitsHeld;
        });
      result.percent = (Math.round(result.percent * 100) / 100).toFixed(2);
      result.contributions = (Math.round(result.contributions * 100) / 100).toFixed(2);
      result.values = (Math.round(result.values * 100) / 100).toFixed(2);

      return result;
    },

    processSidebarWidth() {
      switch (this.columnCount) {
        case 1: {
          this.sidebarWidth = 475;
          break;
        }
        case 2: {
          this.sidebarWidth = 800;
          break;
        }
        case 3: {
          this.sidebarWidth = 950;
          break;
        }
        default: {
          this.sidebarWidth = 475;
        }
      }
    },

    async getForm(formName) {
      this.loading = true;
      try {
        let response = await this.$api.get(
          `/datadictionary/GetFormElements?formName=${formName}&planId=${this.currentPlanId}`
        );

        this.allElements = response.data;
        if (response.data.length)
          this.formElements = response.data.filter((f) => f.Visible == true);
        this.getProfileList();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    async getHeaders() {
      try {
        const response = await this.$api.get(
          `/datadictionary/GetGridHeaders?formName=InvestChoices&planId=${this.currentPlanId}`
        );

        if (response.data.length) {
          const data = response.data.filter((item) => item.Visible);
          data.sort((a, b) => a.ColumbOrder - b.ColumbOrder);
          this.headers = data.map((item) => ({
            text: item.HeaderText,
            value: item.Datafield,
            align: item.Align.toLowerCase(),
            format: item.FieldFormat,
          }));
        }
      } catch (err) {
        console.log(err.message);
      }
    },

    async getProfileList() {
      this.loading = true;
      try {
        const response = await this.$api.get(
          '/Profiles/GetProfileList?orderBy=Fund&membershipId=' + this.memberId
        );

        this.profilesList = response.data;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },

    async getFundList(managerId) {
      this.loading = true;
      try {
        const response = await this.$api.get('/Funds/GetFundList?managerId=' + managerId);

        this.selectedManagerFundList = response.data;
        if (this.formElements) {
          const fundIdField = this.formElements.find((el) => el.FieldName === 'FundId');
          fundIdField.LookupItems = [
            ...response.data.map((fund) => ({ Id: fund.PortfolioId, Text: fund.PortfolioName })),
          ];

          this.formElements = [...this.formElements];
        }

        if (
          !this.selectedManagerFundList.find((f) => f.PortfolioId === this.selectedProfile.FundId)
        ) {
          this.selectedProfile.FundId = null;
        }
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },

    async getManagerList() {
      try {
        let response = await this.$api.get('/funds/getManagerList');
        var data = response.data;
        this.managerList = data;
      } catch (err) {
        console.error(err);
      }
    },

    async getLifestyleList() {
      try {
        let response = await this.$api.get(
          '/lifestyle/GetLifestyleList?planId=' + this.currentPlanId
        );
        this.lifestyleList = response.data;
      } catch (err) {
        console.error(err);
      }
    },

    async addProfile() {
      /*const newProfile = {};
      this.allElements.forEach((el) => {
        newProfile[el.FieldName] = el.Value;
      });
      this.formElements.forEach((el) => {
        newProfile[el.FieldName] = el.Value;
      });
      newProfile.MembershipId = this.memberId;
      newProfile.ProfileId = 0;*/
      this.selectedProfile.ProfileId = 0;
      this.selectedProfile.MembershipId = this.memberId;

      try {
        await this.$api.post('/Profiles/UpdateInvestChoice', this.selectedProfile);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Profile was added',
        });
        this.getProfileList();
      } catch (err) {
        console.log(err.message);
      }
    },

    async updateProfile() {
      this.loading = true;
      try {
        /*this.formElements.forEach((el) => {
          this.selectedProfile[el.FieldName] = el.Value;
        });*/
        await this.$api.post('/Profiles/UpdateInvestChoice', this.selectedProfile);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Invest choice was updated',
        });
        this.getProfileList();
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },

    async deleteProfile() {
      this.loading = true;
      try {
        await this.$api.delete('/Profiles/DeleteInvestChoice?Id=' + this.selectedProfile.ProfileId);

        this.getProfileList();
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },

    cancelAdjustment() {
      this.profileAdjustment = {};
      this.showAdjustment = false;
    },

    async okAdjustment() {
      if (!this.$refs.adjustmentForm.validate()) {
        return;
      }

      this.profileAdjustment.ChoiceId = this.selectedProfile.ProfileId;
      this.profileAdjustment.FundId = this.selectedProfile.FundId;
      this.profileAdjustment.MemberId = this.selectedProfile.MembershipId;

      try {
        const response = await this.$api.post(
          '/Profiles/ProfileAdjustment',
          this.profileAdjustment
        );
        console.log(response);
      } catch (error) {
        console.log(error);
      } finally {
        this.profileAdjustment = {};
        this.showAdjustment = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.sidebar {
  margin-bottom: 30px;
}

.sidebar h3 {
  margin-bottom: 20px;
}

.formPanel {
  margin-top: 5px;

  .v-input--checkbox,
  .v-input--radio-group--row {
    margin-top: 8px;
    margin-left: 5px;
    margin-bottom: 10px;
  }
  .v-input {
    max-width: 420px;
  }
}

.btnsContainer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: white;
  padding: 10px;
  display: flex;
  justify-content: space-between;
}
.btnsContainer > div {
  display: inline-block;
}

.profiles {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 30px;
}

.theme--light.v-data-table {
  background-color: transparent;
}

.currentValuationValues {
  display: flex;
  flex-flow: column wrap;
  max-height: 90px;
  align-content: space-between;
}

.currentValuationValues div {
  min-width: 170px;
  display: flex;
  justify-content: space-between;
  font-size: 0.875rem;
  line-height: 2;
}

.totalsTable tbody tr:nth-child(odd) {
  background-color: transparent;
}

.totalsTable tbody tr {
  cursor: default;
}

.totalsTable tbody tr:hover {
  background-color: #bbdefb !important;
}
</style>
